import { ReactLenis } from 'lenis/react'
import { Suspense } from 'react'
import * as styles from './App.module.scss'
import Frame from './components/interface/Frame/Frame'
import Header from './components/interface/Header/Header'
import Loader from './components/interface/Loader/Loader'
import Modal from './components/interface/Modal/Modal'
import AppModals from './containers/AppModals/AppModals'
import Routes from './containers/Routes/Routes'

/**
 * The `App`
 * @returns {React.ReactElement} the element
 */
export default function App () {
  return (
    <div className={styles.container}>
        <ReactLenis
          root
          options={{
            smooth: true,
            syncTouch: false,
            gestureOrientation: 'vertical',
            normalizeWheel: false,
            syncTouchLerp: 0.075
          }}
        >
          <Suspense fallback={<div />}>
            <Routes />
          </Suspense>
        </ReactLenis>
        <Loader.GLSuspense />
        <Header />
        <Modal />
        <Loader.Display />
        <AppModals />
        <Frame />
    </div>
  )
}
